import { ActionStore, SystemStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';

const initialState: SystemStore = {
  anchors: {},
  language: 'fr',
  loading: false,
  os: '',
  platform: '',
  title: '',
};

const reducer = (
  state = initialState,
  action: ActionStore<SystemStore>,
): SystemStore => {
  switch (action.type) {
    case Reducers.LOADING:
      return { ...state, loading: true };
    case Reducers.READY:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default reducer;
